export { House as default } from '@material-ui/icons';
